<ion-card>
    <ion-card-content>
        <ion-fab vertical="center" horizontal="end" >
            <ion-fab-button (tap)="eqListModal()" size="small" color="light">
                <ion-icon name="hammer"></ion-icon>
            </ion-fab-button>
        </ion-fab>
        <ion-label>Select Plant items/Consumables...</ion-label>
    </ion-card-content>
    <ion-card-content *ngIf="currentGroupedItems.length > 0">
        <ion-list>
            <ion-item-sliding *ngFor="let item of currentGroupedItems; let i = index;" slot="start">
                <ion-item>
                    <ion-label><p>{{item.description}}</p></ion-label>
                    <ion-input type="number" class="ion-text-end" maxlength="6" [(ngModel)]="item.qty"
                               (ionChange)="checkQty($event, item)" placeholder="Qty" debounce="300">
                    </ion-input>
                </ion-item>
                <ion-item-options side="start">
                    <ion-item-option color="none" class="ion-float-right">
                        <ion-button color="danger" (click)="removeItem(item, i)">
                            <ion-icon name="trash" slot="icon-only"></ion-icon>
                        </ion-button>
                    </ion-item-option>
                </ion-item-options>
            </ion-item-sliding>
        </ion-list>
        <!--        <ion-list>-->
        <!--            <ion-list-header>-->
        <!--                <ion-label>Temporary (test purpose)</ion-label>-->
        <!--            </ion-list-header>-->
        <!--            <ion-item *ngFor="let line of document.detailLines">-->
        <!--                <ion-label>-->
        <!--                    <p>{{line.pdesc}} {{line.description}}</p>-->
        <!--                    <p>{{line.qty}} {{line.contractDocumentNumber}}</p>-->
        <!--                </ion-label>-->
        <!--            </ion-item>-->
        <!--        </ion-list>-->
    </ion-card-content>
</ion-card>
